import script from "./MFAPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MFAPage.vue?vue&type=script&setup=true&lang=js"

import "./MFAPage.vue?vue&type=style&index=0&id=054f5678&lang=scss"

const __exports__ = script;

export default __exports__